import Swiper from 'swiper';
import {Pagination, Keyboard, A11y, Autoplay} from 'swiper/modules';

new Swiper('.swiper-hero', {
// configure Swiper to use modules
  modules: [Pagination, Keyboard, A11y, Autoplay],
  slidesPerView: 1,
  keyboard: {
    enabled: true,
  },
  autoplay: {
    delay: 10000,
  },
  pagination: {
    enabled: true,
    el: '.swiper-pagination',
    clickable: true,
  },
});


function updateAnnoucementBarHeights() {
  let bannerHeight = 0;

  const visionBanner = document.getElementById('vision-banner');
  const topBanner = document.getElementById('top-banner');

  if (visionBanner) {
    bannerHeight += visionBanner.offsetHeight;
  }

  if (topBanner) {
    bannerHeight += topBanner.offsetHeight;
  }

  document.documentElement.style.setProperty('--annoucement-banner-height', `${bannerHeight}px`);
}

window.addEventListener('load', updateAnnoucementBarHeights);
window.addEventListener('resize', updateAnnoucementBarHeights);
window.addEventListener('banner:updated', updateAnnoucementBarHeights);
